/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Components } from '../../../core/models/common/Components';
import { IVisitor } from '../../../core/visitors/IVisitor';
import { IOas30Visitor } from '../visitors/IOas30Visitor';
import { Oas30SchemaDefinition } from './Oas30SchemaDefinition';
import { Oas30ResponseDefinition } from './Oas30ResponseDefinition';
import { Oas30ParameterDefinition } from './Oas30ParameterDefinition';
import { Oas30ExampleDefinition } from './Oas30ExampleDefinition';
import { Oas30RequestBodyDefinition } from './Oas30RequestBodyDefinition';
import { Oas30HeaderDefinition } from './Oas30HeaderDefinition';
import { Oas30SecurityScheme } from './Oas30SecurityScheme';
import { Oas30LinkDefinition } from './Oas30LinkDefinition';
import { Oas30CallbackDefinition } from './Oas30CallbackDefinition';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @class
 * @extends Components
 * @author eric.wittmann@gmail.com
 */
export class Oas30Components extends Components {
    public schemas : any = <any>({});

    public responses : any = <any>({});

    public parameters : any = <any>({});

    public examples : any = <any>({});

    public requestBodies : any = <any>({});

    public headers : any = <any>({});

    public securitySchemes : any = <any>({});

    public links : any = <any>({});

    public callbacks : any = <any>({});

    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let viz : IOas30Visitor = <IOas30Visitor><any>visitor;
        viz.visitComponents(this);
    }

    /**
     * Creates a schema definition.
     * @param {string} name
     * @return {Oas30SchemaDefinition}
     */
    public createSchemaDefinition(name : string) : Oas30SchemaDefinition {
        let rval : Oas30SchemaDefinition = new Oas30SchemaDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a schema definition.
     * @param {string} name
     * @param {Oas30SchemaDefinition} schemaDefinition
     */
    public addSchemaDefinition(name : string, schemaDefinition : Oas30SchemaDefinition) {
        /* put */(this.schemas[name] = schemaDefinition);
    }

    /**
     * Gets a single schema definition by name.
     * @param {string} name
     * @return {Oas30SchemaDefinition}
     */
    public getSchemaDefinition(name : string) : Oas30SchemaDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.schemas, name);
    }

    /**
     * Removes a single schema definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30SchemaDefinition}
     */
    public removeSchemaDefinition(name : string) : Oas30SchemaDefinition {
        return /* remove */(map => { let deleted = this.schemas[name];delete this.schemas[name];return deleted;})(this.schemas);
    }

    /**
     * Gets a list of all schema definitions.
     * @return {Oas30SchemaDefinition[]}
     */
    public getSchemaDefinitions() : Array<Oas30SchemaDefinition> {
        let rval : Array<Oas30SchemaDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.schemas));
        return rval;
    }

    /**
     * Creates a response definition.
     * @param {string} name
     * @return {Oas30ResponseDefinition}
     */
    public createResponseDefinition(name : string) : Oas30ResponseDefinition {
        let rval : Oas30ResponseDefinition = new Oas30ResponseDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a response definition.
     * @param {string} name
     * @param {Oas30ResponseDefinition} responseDefinition
     */
    public addResponseDefinition(name : string, responseDefinition : Oas30ResponseDefinition) {
        /* put */(this.responses[name] = responseDefinition);
    }

    /**
     * Gets a single response definition by name.
     * @param {string} name
     * @return {Oas30ResponseDefinition}
     */
    public getResponseDefinition(name : string) : Oas30ResponseDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.responses, name);
    }

    /**
     * Removes a single response definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30ResponseDefinition}
     */
    public removeResponseDefinition(name : string) : Oas30ResponseDefinition {
        return /* remove */(map => { let deleted = this.responses[name];delete this.responses[name];return deleted;})(this.responses);
    }

    /**
     * Gets a list of all response definitions.
     * @return {Oas30ResponseDefinition[]}
     */
    public getResponseDefinitions() : Array<Oas30ResponseDefinition> {
        let rval : Array<Oas30ResponseDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.responses));
        return rval;
    }

    /**
     * Creates a parameter definition.
     * @param {string} name
     * @return {Oas30ParameterDefinition}
     */
    public createParameterDefinition(name : string) : Oas30ParameterDefinition {
        let rval : Oas30ParameterDefinition = new Oas30ParameterDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a parameter definition.
     * @param {string} name
     * @param {Oas30ParameterDefinition} parameterDefinition
     */
    public addParameterDefinition(name : string, parameterDefinition : Oas30ParameterDefinition) {
        /* put */(this.parameters[name] = parameterDefinition);
    }

    /**
     * Gets a single parameter definition by name.
     * @param {string} name
     * @return {Oas30ParameterDefinition}
     */
    public getParameterDefinition(name : string) : Oas30ParameterDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.parameters, name);
    }

    /**
     * Removes a single parameter definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30ParameterDefinition}
     */
    public removeParameterDefinition(name : string) : Oas30ParameterDefinition {
        return /* remove */(map => { let deleted = this.parameters[name];delete this.parameters[name];return deleted;})(this.parameters);
    }

    /**
     * Gets a list of all parameter definitions.
     * @return {Oas30ParameterDefinition[]}
     */
    public getParameterDefinitions() : Array<Oas30ParameterDefinition> {
        let rval : Array<Oas30ParameterDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.parameters));
        return rval;
    }

    /**
     * Creates a example definition.
     * @param {string} name
     * @return {Oas30ExampleDefinition}
     */
    public createExampleDefinition(name : string) : Oas30ExampleDefinition {
        let rval : Oas30ExampleDefinition = new Oas30ExampleDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a example definition.
     * @param {string} name
     * @param {Oas30ExampleDefinition} exampleDefinition
     */
    public addExampleDefinition(name : string, exampleDefinition : Oas30ExampleDefinition) {
        /* put */(this.examples[name] = exampleDefinition);
    }

    /**
     * Gets a single example definition by name.
     * @param {string} name
     * @return {Oas30ExampleDefinition}
     */
    public getExampleDefinition(name : string) : Oas30ExampleDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.examples, name);
    }

    /**
     * Removes a single example definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30ExampleDefinition}
     */
    public removeExampleDefinition(name : string) : Oas30ExampleDefinition {
        return /* remove */(map => { let deleted = this.examples[name];delete this.examples[name];return deleted;})(this.examples);
    }

    /**
     * Gets a list of all example definitions.
     * @return {Oas30ExampleDefinition[]}
     */
    public getExampleDefinitions() : Array<Oas30ExampleDefinition> {
        let rval : Array<Oas30ExampleDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.examples));
        return rval;
    }

    /**
     * Creates a request body definition.
     * @param {string} name
     * @return {Oas30RequestBodyDefinition}
     */
    public createRequestBodyDefinition(name : string) : Oas30RequestBodyDefinition {
        let rval : Oas30RequestBodyDefinition = new Oas30RequestBodyDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a request body definition.
     * @param {string} name
     * @param {Oas30RequestBodyDefinition} requestBodyDefinition
     */
    public addRequestBodyDefinition(name : string, requestBodyDefinition : Oas30RequestBodyDefinition) {
        /* put */(this.requestBodies[name] = requestBodyDefinition);
    }

    /**
     * Gets a single request body definition by name.
     * @param {string} name
     * @return {Oas30RequestBodyDefinition}
     */
    public getRequestBodyDefinition(name : string) : Oas30RequestBodyDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.requestBodies, name);
    }

    /**
     * Removes a single request body definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30RequestBodyDefinition}
     */
    public removeRequestBodyDefinition(name : string) : Oas30RequestBodyDefinition {
        return /* remove */(map => { let deleted = this.requestBodies[name];delete this.requestBodies[name];return deleted;})(this.requestBodies);
    }

    /**
     * Gets a list of all request body definitions.
     * @return {Oas30RequestBodyDefinition[]}
     */
    public getRequestBodyDefinitions() : Array<Oas30RequestBodyDefinition> {
        let rval : Array<Oas30RequestBodyDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.requestBodies));
        return rval;
    }

    /**
     * Creates a header definition.
     * @param {string} name
     * @return {Oas30HeaderDefinition}
     */
    public createHeaderDefinition(name : string) : Oas30HeaderDefinition {
        let rval : Oas30HeaderDefinition = new Oas30HeaderDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a header definition.
     * @param {string} name
     * @param {Oas30HeaderDefinition} headerDefinition
     */
    public addHeaderDefinition(name : string, headerDefinition : Oas30HeaderDefinition) {
        /* put */(this.headers[name] = headerDefinition);
    }

    /**
     * Gets a single header definition by name.
     * @param {string} name
     * @return {Oas30HeaderDefinition}
     */
    public getHeaderDefinition(name : string) : Oas30HeaderDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.headers, name);
    }

    /**
     * Removes a single header definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30HeaderDefinition}
     */
    public removeHeaderDefinition(name : string) : Oas30HeaderDefinition {
        return /* remove */(map => { let deleted = this.headers[name];delete this.headers[name];return deleted;})(this.headers);
    }

    /**
     * Gets a list of all header definitions.
     * @return {Oas30HeaderDefinition[]}
     */
    public getHeaderDefinitions() : Array<Oas30HeaderDefinition> {
        let rval : Array<Oas30HeaderDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.headers));
        return rval;
    }

    /**
     * Creates a security scheme definition.
     * @param {string} name
     * @return {Oas30SecurityScheme}
     */
    public createSecurityScheme(name : string) : Oas30SecurityScheme {
        let rval : Oas30SecurityScheme = new Oas30SecurityScheme(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a security scheme definition.
     * @param {string} name
     * @param {Oas30SecurityScheme} securityScheme
     */
    public addSecurityScheme(name : string, securityScheme : Oas30SecurityScheme) {
        /* put */(this.securitySchemes[name] = securityScheme);
    }

    /**
     * Gets a single security scheme definition by name.
     * @param {string} name
     * @return {Oas30SecurityScheme}
     */
    public getSecurityScheme(name : string) : Oas30SecurityScheme {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.securitySchemes, name);
    }

    /**
     * Removes a single security scheme definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30SecurityScheme}
     */
    public removeSecurityScheme(name : string) : Oas30SecurityScheme {
        return /* remove */(map => { let deleted = this.securitySchemes[name];delete this.securitySchemes[name];return deleted;})(this.securitySchemes);
    }

    /**
     * Gets a list of all security scheme definitions.
     * @return {Oas30SecurityScheme[]}
     */
    public getSecuritySchemes() : Array<Oas30SecurityScheme> {
        let rval : Array<Oas30SecurityScheme> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.securitySchemes));
        return rval;
    }

    /**
     * Creates a link definition.
     * @param {string} name
     * @return {Oas30LinkDefinition}
     */
    public createLinkDefinition(name : string) : Oas30LinkDefinition {
        let rval : Oas30LinkDefinition = new Oas30LinkDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a link definition.
     * @param {string} name
     * @param {Oas30LinkDefinition} linkDefinition
     */
    public addLinkDefinition(name : string, linkDefinition : Oas30LinkDefinition) {
        /* put */(this.links[name] = linkDefinition);
    }

    /**
     * Gets a single link definition by name.
     * @param {string} name
     * @return {Oas30LinkDefinition}
     */
    public getLinkDefinition(name : string) : Oas30LinkDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.links, name);
    }

    /**
     * Removes a single link definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30LinkDefinition}
     */
    public removeLinkDefinition(name : string) : Oas30LinkDefinition {
        return /* remove */(map => { let deleted = this.links[name];delete this.links[name];return deleted;})(this.links);
    }

    /**
     * Gets a list of all link definitions.
     * @return {Oas30LinkDefinition[]}
     */
    public getLinkDefinitions() : Array<Oas30LinkDefinition> {
        let rval : Array<Oas30LinkDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.links));
        return rval;
    }

    /**
     * Creates a callback definition.
     * @param {string} name
     * @return {Oas30CallbackDefinition}
     */
    public createCallbackDefinition(name : string) : Oas30CallbackDefinition {
        let rval : Oas30CallbackDefinition = new Oas30CallbackDefinition(name);
        rval._ownerDocument = this._ownerDocument;
        rval._parent = this;
        return rval;
    }

    /**
     * Adds a callback definition.
     * @param {string} name
     * @param {Oas30CallbackDefinition} callbackDefinition
     */
    public addCallbackDefinition(name : string, callbackDefinition : Oas30CallbackDefinition) {
        /* put */(this.callbacks[name] = callbackDefinition);
    }

    /**
     * Gets a single callback definition by name.
     * @param {string} name
     * @return {Oas30CallbackDefinition}
     */
    public getCallbackDefinition(name : string) : Oas30CallbackDefinition {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this.callbacks, name);
    }

    /**
     * Removes a single callback definition and returns it.  This may return null or undefined if none found.
     * @param {string} name
     * @return {Oas30CallbackDefinition}
     */
    public removeCallbackDefinition(name : string) : Oas30CallbackDefinition {
        return /* remove */(map => { let deleted = this.callbacks[name];delete this.callbacks[name];return deleted;})(this.callbacks);
    }

    /**
     * Gets a list of all callback definitions.
     * @return {Oas30CallbackDefinition[]}
     */
    public getCallbackDefinitions() : Array<Oas30CallbackDefinition> {
        let rval : Array<Oas30CallbackDefinition> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this.callbacks));
        return rval;
    }
}
Oas30Components["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Components";
Oas30Components["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




